import React, { useContext, useMemo, useState } from 'react'
import styles from "../css/Settings.module.css"
import { PageContext } from '../../board/js/Notes.js';
import LoadingButton from "../../Loaders/js/LoadingButton.js"
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useRef } from 'react';
import { updateProfile } from '../../../actions/authActions.js';
import { AUTH_RESET } from '../../../actions/authTypes.js';
import { AiOutlineArrowRight, AiOutlineMail } from 'react-icons/ai';
import { FiEdit, FiLock } from 'react-icons/fi';
import useOverflow from '../../../hooks/useOverflow.js';

const Profile = ({goToEmail,goToPassword}) => {
    const [,setPageModals] = useContext(PageContext)
    const inputRef = useRef(null)
    const user = useSelector((state) => state.authState.user)
    const loading = useSelector((state) => state.authState.loading)
    const [modifiedName,setModifiedName] = useState(user?.fullname)
    const dispatch = useDispatch()
    const contentRef = useRef(null)
    const hasOverflow = useOverflow(contentRef)

    useEffect(()=>{
        return () => {
            dispatch({type: AUTH_RESET})
        }
    },[dispatch])

    useEffect(()=>{
        if (document.activeElement !== inputRef.current){
            setModifiedName(user.fullname)
        }
    },[user])

    const closeModal = () => {
        setPageModals((prevState)=>{
            let copy = {...prevState}
            copy.settings = false
            return copy
        })
    }

    const isDisabled = useMemo(()=>{
        if (!modifiedName?.trim() || (user.fullname.trim() === modifiedName.trim())){
            return true
        }
        else{
            return false
        }
    },[modifiedName,user.fullname])

    const handleSubmit = async (e) => {
        e.preventDefault()
        document.activeElement.blur()
        dispatch(updateProfile({fullname: modifiedName}))
    }

    const handleKeyDown = (e) => {
        const isPrintableCharacter = e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey
        if (isPrintableCharacter){
            if (modifiedName.length === 25){
                if (e.target.parentNode){
                    e.target.parentNode?.classList.add(styles.shake)
                }
                setTimeout(()=>{
                if (e.target.parentNode){
                    e.target.parentNode?.classList.remove(styles.shake)
                }
                },500)
            }
        }
    }

  return (
    <form className = {`${styles.form} ${hasOverflow ? styles.overflowed : ""} nested-container`} onSubmit = {handleSubmit}>
      <div className = {`${styles.body} nested-container`} ref = {contentRef}>
        <div className={styles.avatarSection}>
          <div className={styles.avatar}>{user?.fullname?.charAt(0)?.toLowerCase()}</div>
          <div className={styles.avatarInfo}>
            <div className={styles.avatarName}>{user.fullname}</div>
            <div className={styles.avatarEmail} style = {{ textWrap: !user.isDemoUser ? "nowrap" : "wrap"}}>{user.email}</div>
          </div>
        </div>
        <div className={styles.field}>
          <label htmlFor = "fullname" className={styles.label}>Full Name</label>
          <div className = {styles.inputContainer}>
            <input 
              name = "fullname" 
              className = {styles.input} 
              type = "text" 
              value = {modifiedName}
              onChange = {(e)=>setModifiedName(e.target.value)}
              maxLength = {25}
              onKeyDown = {handleKeyDown}
            />
          </div>
        </div>
        <div className={styles.field}>
          <label htmlFor = "email" className={styles.label}>Email</label>
          <div className={styles.inputRow}>
            <div className={styles.inputWrap}>
              <div className = {styles.inputContainer}>
                <input
                  name = "email"
                  className={styles.input}
                  type = "email"
                  value = {user.email}
                  readOnly
                />
              </div>
              <span className={styles.inputIcon}>
                <AiOutlineMail/>
              </span>
            </div>
            <button data-testid = "email-tab" type = "button" className={styles.editLink} onClick = {()=>goToEmail()}>
              <FiEdit/> Edit email
            </button>
          </div>
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Password</label>
          <button data-testid = "password-tab" type = "button" className={styles.changeBtn} onClick = {()=>goToPassword()}>
            <FiLock/> Change your password
          </button>
        </div>
      </div>
      <div className={styles.footer}>
        <button type = "button" className={styles.cancelBtn} onClick = {()=>closeModal()}>Cancel</button>
        <button type = "submit" className={styles.submitBtn} disabled = {isDisabled}>
            Save Changes
            <div className={styles.btnIcon}>
                <AiOutlineArrowRight/>
            </div>
            {loading && <LoadingButton/>}
        </button>
      </div>
    </form>
  )
}

export default Profile